import { useListingCatalog } from 'app/hooks/use-listing-catalog';
import { withErrorBoundary } from 'app/components/error-boundary';
import type { NavigationScreen } from 'app/types/navigation';
import { withOptionalMetrics } from 'app/utils/performance/with-metrics';
import { usePageTitle, useUISize } from 'app/utils/web-helpers';
import * as React from 'react';
import { InterestsScreenLarge } from './interests.large';
import { InterestsScreenSmall } from './interests.small';

const InterestsScreenInner: NavigationScreen<'interests'> = (props) => {
  const { isSmallUI } = useUISize();

  const setPageTitle = usePageTitle('interests');
  React.useEffect(() => setPageTitle('title'), [setPageTitle]);

  const { tagsEnabled } = useListingCatalog();
  const { navigation } = props;
  React.useEffect(() => {
    if (!tagsEnabled) navigation.navigate('quickNew', undefined, { pop: true });
  }, [navigation, tagsEnabled]);

  if (!tagsEnabled) return null;

  if (isSmallUI) {
    return <InterestsScreenSmall {...props} />;
  }
  return <InterestsScreenLarge {...props} />;
};

export const InterestsScreen: NavigationScreen<'interests'> = withOptionalMetrics(
  'InterestsScreen',
  withErrorBoundary(InterestsScreenInner),
);
